import { addModal } from 'weblite-web-modal-viewer'
// component
import { RoomProfileMenu, RoomProfileMenuProps } from './room-profile-menu'

const COMPONENT_ID = 'roomProfileMenu'

export const showRoomProfileMenu = (
  props: Omit<RoomProfileMenuProps, 'isOpen'>,
  preventBackClick = false,
) => addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: RoomProfileMenu },
}
